export default __webpack_public_path__ + "static/media/copy.57bb1668.svg";